import { useAppBridge } from "@shopify/app-bridge-react";
import { Toast } from "@shopify/app-bridge/actions";
import { Frame, Page } from "@shopify/polaris";
import { useEffect } from "react";
import { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Api from "../../helpers/api";
import CustomerForm from "./Form";

const EditCustomer = props => {
    const app = useAppBridge();
    const history = useHistory();
    const {customerId} = useParams();
    const [customer, setCustomer] = useState(null);

    useEffect(() => {
        Api.getCustomer(customerId).then( response => setCustomer( response.data.data) );
    }, []);

    return customer && (
        <Frame>
            <Page title={`Edit customer`} breadcrumbs={[
                { content: 'Customer', onAction: () => { history.goBack()} }
            ]}>
                <CustomerForm customer={customer} updating={true} onCustomerCreated={updatedCustomer => {
                    Toast
                        .create(app, {
                            message: 'Customer was updated',
                            duration: 3000,
                        })
                        .dispatch(Toast.Action.SHOW);

                    setCustomer(customer);
                }} />
            </Page>
        </Frame>
    );
}

export default EditCustomer;
